import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[miqStopKeydown]',
  standalone: false,
})
export class StopKeydownDirective {
  @Input() preventDefault = false;

  @HostListener('keydown', ['$event']) onKeydown(e) {
    if (this.preventDefault) {
      e.preventDefault();
    } else {
      e.stopPropagation();
    }
  }
}
